import Scale from './scale.es6';
import Star from './star.es6';

export default class Starry {
    constructor() {
        this.$starrys = [...document.querySelectorAll('.js-starry')];

        this._init();
    }

    _init() {
        this._initStarry();
        this._eventBind();
    }

    _initStarry() {
        for (const $starry of this.$starrys) {
            const ctx = $starry.getContext('2d');
            this._createStars($starry);
            this._repeatAnimate($starry, ctx);
        }
    }

    _eventBind() {
        let timer;
        let prevWidth = window.innerWidth;

        window.addEventListener('resize', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (prevWidth == window.innerWidth) return;
                prevWidth = window.innerWidth;
                for (const $starry of this.$starrys) {
                    this._createStars($starry);
                }
            }, 300);
        });
    }

    _createStars($starry) {
        const width = $starry.clientWidth;
        const height = $starry.clientHeight;
        const num = (width * height) / 1000;

        // キャンバスのサイズを設定
        $starry.width = width;
        $starry.height = height;

        // スケールのインスタンスを作成
        $starry.scale = new Scale();

        // 星をリセット
        $starry.stars = [];

        // キャンバスのサイズに応じて、星のインスタンスを作成
        for (let i = 0; i < num; i++) {
            const star = new Star(width, height);
            $starry.stars.push(star);
        }
    }

    _repeatAnimate($starry, ctx) {
        // 画面をクリア
        ctx.clearRect(0, 0, $starry.width, $starry.height);

        // 現在の描画状態を保存
        ctx.save();

        $starry.scale.update();
        $starry.scale.draw($starry, ctx);

        for (const star of $starry.stars) {
            star.update();
            star.draw(ctx);
        }

        // 保存した描画状態を復元
        ctx.restore();

        // アニメーションを繰り返す
        requestAnimationFrame(() => this._repeatAnimate($starry, ctx));
    }
}
